export default "__VITE_ASSET__20e91c7c__"